import {createContext, PropsWithChildren, useContext} from 'react';

import {UseStoredFilters, UseStoredFiltersActions} from 'filters/features/types';
import {PageFilter} from 'filters/types';

type FilterActionsState = {
  useStoredFilters: UseStoredFilters;
  useStoredFiltersActions: UseStoredFiltersActions;
  useApplyFilter: () => (filter: PageFilter, savedFilterId?: string) => Promise<void> | void;
};

const FilterActionsContext = createContext<FilterActionsState>(null as never);
FilterActionsContext.displayName = 'FilterActions';

/**
 * Provider with shared actions for FilterDialog and FilterTopbar
 */
export const FilterActionsProvider = ({children, ...value}: PropsWithChildren<FilterActionsState>) => {
  return <FilterActionsContext.Provider value={value}>{children}</FilterActionsContext.Provider>;
};

export const useFilterActionsContext = () => {
  const context = useContext(FilterActionsContext);

  if (!context) {
    throw new Error('useFilterActionsContext must be used within a FilterActionsProvider');
  }

  return context;
};
